import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'DinoDealz';
const DEFAULT_DESCRIPTION = 'Hand picked daily deals to save you money on the things you actually use. We work across various platforms to carefully pick deals that are great value!';
const DEFAULT_IMAGE = 'https://dinodealz.com/share.png'; // 1200x630 preview image for Facebook, WhatsApp, X

export default function SEO({ title, description, image, url }) {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const pageDescription = description || DEFAULT_DESCRIPTION;
  const pageImage = image || DEFAULT_IMAGE;
  const pageUrl = url || (typeof window !== 'undefined' ? window.location.href : 'https://dinodealz.com');

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:url" content={pageUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />
    </Helmet>
  );
}
